import React from "react";
import logger from "logger";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { EnhancedTableHead } from "./EnhancedTableHead";
import { EnhancedTableToolbar } from "./EnhancedTableToolbar";
import { Row } from "./Row";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable(props) {
  const { data, usercachereport } = props;
  const classes = useStyles();
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("createtime");
  const [selected, setSelected] = React.useState([]);

  const [namefilter, setNamefilter] = React.useState(null);
  const [emailfilter, setEmailfilter] = React.useState(null);

  const rows = [];

  if (data) {
    const adminPageKeys = Object.keys(data);
    adminPageKeys.map((key) => {
      const value = data[key];
      const emails = value.emails;
      let totalservers = 0;
      const uniqueServers = [];
      let totalAccounts = 0;
      let activeAccounts = 0;
      const emailKeys = Object.keys(emails);
      emailKeys.map((key2) => {
        if (!key2 || key2.trim().length === 0) {
          return;
        }
        const { servers, duration, refillstampmillis } = value.emails[key2];
        totalservers += servers.length;
        servers.forEach((server) => {
          if (uniqueServers.indexOf(server) === -1) {
            uniqueServers.push(server);
          }
        });
        const currentMillis = new Date().getTime();
        const endTime = parseInt(refillstampmillis) + parseInt(duration) * 1000;
        let active = false;
        totalAccounts++;
        if (endTime > currentMillis) {
          active = true;
        }
        if (active) {
          activeAccounts++;
        }
      });
      rows.push({
        name: key,
        credits: parseInt(value.credits),
        createtime: new Date(value.registertime).getTime(),
        accounts: totalAccounts,
        servers: totalservers,
        uniqueServers: uniqueServers.length,
        activeAccounts,
        emailData: emails,
        contribution: activeAccounts,
        password: value.password,
      });
    });
  }

  if (usercachereport) {
    const usercachedData = {};
    usercachereport.forEach((report) => {
      const { email } = report;
      usercachedData[email] = report;
    });
    rows.forEach((row) => {
      const { emailData } = row;
      let taskcount = 0;
      Object.keys(emailData).forEach((email) => {
        const thisCachedData = usercachedData[email];
        const thisEmailData = emailData[email];
        if (thisCachedData) {
          thisEmailData.cachedData = thisCachedData;
          taskcount += thisCachedData.threadCount;
        }
      });
      row.taskcount = taskcount;
    });
  }

  let filteredData = rows.filter((row) => {
    let filterCriteria = namefilter;
    let filterText = row.name || "";
    if (filterCriteria && filterCriteria.trim().length > 0) {
      if (filterText.indexOf(filterCriteria) === -1) {
        return false;
      }
    }
    filterCriteria = emailfilter;
    filterText = Object.keys(row.emailData).join(",") || "";
    if (filterCriteria && filterCriteria.trim().length > 0) {
      if (filterText.indexOf(filterCriteria) === -1) {
        return false;
      }
    }
    return true;
  });

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = filteredData.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          rows={filteredData}
          namefilter={namefilter}
          setNamefilter={setNamefilter}
          emailfilter={emailfilter}
          setEmailfilter={setEmailfilter}
        />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={"small"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={filteredData.length}
            />
            <TableBody>
              {stableSort(filteredData, getComparator(order, orderBy)).map(
                (row, index) => {
                  return (
                    <StyledTableRow
                      row={row}
                      index={index}
                      isSelected={isSelected}
                      handleClick={handleClick}
                      key={row.name + "_maindata"}
                    />
                  );
                }
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "black",
    },
  },
}))(Row);
